import { useQuery } from '@tanstack/react-query';
import type { EnergyGauge } from '@/types/energy';
import { REFRESH_INTERVALS } from '../constants';

export function useEnergy() {
  return useQuery({
    queryKey: ['energy', 'current'],
    queryFn: async (): Promise<EnergyGauge[]> => {
      const res = await fetch('/api/energy/current');
      if (!res.ok) throw new Error('Failed to fetch energy');
      return res.json();
    },
    refetchInterval: REFRESH_INTERVALS.current,
    staleTime: 30000,
  });
}
